module.exports = {
    brandInfo: {
        phoneNumber: "13434296444",
        contactEmail: "info@myloan.ca",
        address: `1330 Carling Avenue, Ottawa, ON K1Z 7K8`,
        copyright: `© ${new Date().getFullYear()} MyLoan`,
        defaultCampaignId: "246",
    },

    images: {
        icon: "images/myloan-logo.webp",
        logo: "images/myloan-logo.webp",
    },

    project: "myloan-credit-application",
    name: "MyLoan",
    description: `Get the best rates`,

    siteUrl: "https://myloan.ca/",
    homeUrl: "/",
    termsUrl: "/terms_of_use",
    privacyPolicyUrl: "/privacy_policy",
    successUrl: "/success",

    hideSuccessCtas: true,
    twilioVerifyMethods: ["sms"],
};
